// ═══════════════════════════════════════════════════════════════════════════
// 📊 ANALYTICS: Rastreamento de Visualizações e Consumo de Reads
// ═══════════════════════════════════════════════════════════════════════════

import { addDoc, collection, serverTimestamp } from "firebase/firestore";

// ✅ ATUALIZADO: Estimativas baseadas em auditoria Firestore real (15/07/2026)
// Baseado em análise de 70.000 leituras/dia com distribuição por ação
const ESTIMATED_READS = {
  // RIT - Operações de visualização e listagem
  loadRits: { reads: 150, type: "read" },          // Query rits com paginação (limit 150)
  loadRitsAll: { reads: 500, type: "read" },       // Query rits sem limite (histórico)
  viewRit: { reads: 1, type: "read" },             // Visualizar 1 RIT específico
  searchRits: { reads: 200, type: "read" },        // Busca em todos os RITs

  // RIT - Operações de escrita
  createRit: { reads: 3, type: "write" },          // Write + KPI update + coord index
  editRit: { reads: 3, type: "write" },            // Write + KPI update + coord index
  deleteRit: { reads: 2, type: "write" },          // Delete + KPI update

  // UAS - Ordens de Voo (vilão identificado: 3 consultas duplicadas)
  loadUasOrdens: { reads: 500, type: "read" },     // Query uas_ordens completa (PDFs, relatórios)
  loadUasOrdensModal: { reads: 150, type: "read" }, // Query uas_ordens modal (últimas 150)
  loadUasOrdensView: { reads: 150, type: "read" },  // Query uas_ordens dashboard (últimas 150)

  // UAS - Áreas
  loadUasAreas: { reads: 300, type: "read" },      // Query uas_areas (todas)
  loadUasAreasModal: { reads: 100, type: "read" }, // Query uas_areas modal

  // Usuários
  loadUsers: { reads: 500, type: "read" },         // Query users (todas, com limite)
  createUser: { reads: 2, type: "write" },         // User creation
  editUser: { reads: 2, type: "write" },           // User edit
  deleteUser: { reads: 1, type: "write" },         // User deletion

  // Academia (listeners/polling)
  loadAcademia: { reads: 300, type: "read" },      // Carregar 6 coleções Academia
  pollAcademia: { reads: 50, type: "read" },       // Polling Academia (reduzido com cache)

  // KPIs
  loadKpis: { reads: 1, type: "read" },            // Carregar counters/kpis
  recalculateKpis: { reads: 1000, type: "read" },  // Recalcular todos KPIs

  // Consultas Públicas
  consulta_publica: { reads: 1, type: "read" },    // Query + validation
  checkRateLimit: { reads: 1, type: "read" },      // Verificar rate limit

  // PDFs
  generatePDF: { reads: 500, type: "read" },       // Gerar PDF (carrega ordens)
  generatePDFResultado: { reads: 50, type: "read" }, // PDF resultado (poucos dados)

  // Atendimento (novo com filtros)
  loadAtendimento: { reads: 200, type: "read" },   // Carregar lista atendimento
  applyFilters: { reads: 50, type: "read" },       // Aplicar filtros (cache)

  // Defalt
  unknown: { reads: 1, type: "read" },
};

export const logAnalytics = async (db, user, action, metadata = {}) => {
  if (!user || !user.uid) return;

  try {
    const config = ESTIMATED_READS[action] || { reads: 1, type: "read" };
    const estimatedReads = metadata.ritCount
      ? config.reads * (metadata.ritCount || 1)
      : config.reads || 1;
    const actionType = config.type || "read";

    await addDoc(collection(db, "user_analytics"), {
      userId: user.uid,
      userName: user.name || "Desconhecido",
      userRole: user.role || "unknown",
      userUnit: user.unitCode || "N/A",
      action: action,
      type: actionType,
      ritCount: metadata.ritCount || 0,
      estimatedReads: estimatedReads,
      duration: metadata.duration || 0,
      details: metadata.details || "",
      timestamp: serverTimestamp(),
      createdAt: new Date(),
    });

    console.log(
      `📊 Analytics: ${user.name} → ${action} (${estimatedReads} reads, tipo: ${actionType})`
    );
  } catch (e) {
    console.error("Erro ao registrar analytics:", e);
  }
};

export const calculateEstimatedReads = (action, ritCount = 1) => {
  return (ESTIMATED_READS[action]?.reads ?? 1) * ritCount;
};
